import React from 'react';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle';

import {
  invitationTokenMissingError,
  parentsLimitExceededError,
} from '../constants';

import styles from './InvitationValidateErrorPage.module.scss';
import ParentsLimitExceededDescription from './ParentsLimitExceededDescription';

interface Props {
  type: 'expired' | 'invalid' | 'parents_limit' | 'token_missing';
  pageTitle: string;
}

const contentMap = {
  expired: {
    title: 'URLの有効期限が切れています',
    description: (
      <>
        認証できませんでした。
        <br />
        再度招待メールをお受け取りください。
      </>
    ),
  },
  invalid: {
    title: '認証URLが不正です',
    description: (
      <>
        認証できませんでした。
        <br />
        再度招待メールをお受け取りください。
      </>
    ),
  },
  parents_limit: {
    title: parentsLimitExceededError.title,
    description: <ParentsLimitExceededDescription />,
  },
  token_missing: {
    title: invitationTokenMissingError.title,
    description: invitationTokenMissingError.description,
  },
} as const;

const InvitationValidateErrorPage: React.FC<Props> = ({ type, pageTitle }) => (
  <SingleColumnTemplate>
    <div className={styles.page}>
      <Jumbotron>
        <JumbotronPanel panelHeaderTitle={pageTitle}>
          <JumbotronTitle>{contentMap[type].title}</JumbotronTitle>
          <JumbotronDescription>
            {contentMap[type].description}
          </JumbotronDescription>
        </JumbotronPanel>
      </Jumbotron>
    </div>
  </SingleColumnTemplate>
);

export default InvitationValidateErrorPage;
